import {ThemeProvider as EmotionThemeProvider} from "@emotion/react";
import {i18n} from "@lingui/core";
import {I18nProvider} from "@lingui/react";
import * as React from "react";
import * as Redux from "react-redux";

import {ErrorBoundary, ErrorFallback} from "@atg-shared/error-boundary";
import {HistoryRouter} from "@atg-shared/router";
import {createNextTheme, ThemeProvider} from "@atg-ui/toolkit/theme";
import {emotionCache, EmotionCacheProvider} from "atg-emotion-cache";
import history from "atg-history";

import {store} from "../store";

type Props = {
    children: React.ReactNode;
    name: string;
    placeholder?: React.ReactNode;
};

/**
 * Overriding overflowY for MuiPaper and MuiDrawer because of how
 * Safari handles overflowY: auto. It will hide the content.
 */
const theme = createNextTheme({
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    overflowY: "visible",
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    overflowY: "visible",
                },
            },
        },
    },
});

function NavigationProviders({children, name, placeholder = <ErrorFallback />}: Props) {
    return (
        <React.StrictMode>
            <I18nProvider i18n={i18n}>
                <ErrorBoundary name={name} placeholder={placeholder}>
                    <EmotionCacheProvider value={emotionCache}>
                        <Redux.Provider store={store}>
                            <HistoryRouter history={history}>
                                <EmotionThemeProvider theme={theme}>
                                    <ThemeProvider theme={theme}>
                                        {children}
                                    </ThemeProvider>
                                </EmotionThemeProvider>
                            </HistoryRouter>
                        </Redux.Provider>
                    </EmotionCacheProvider>
                </ErrorBoundary>
            </I18nProvider>
        </React.StrictMode>
    );
}
export default NavigationProviders;
